import { httpInstance } from '@/services/httpInstance';

const createImageDeviceService = async (dataParam) => {
  let res;
  const endpoint = '/images/v1/images?private=false';
  const dataSent = dataParam;

  await httpInstance.post(
    endpoint,
    dataSent,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default createImageDeviceService;
